<template>
  <div>
    <div>
      <div>
        <p class="heading">四大供餐模式</p>
        <ShowLine></ShowLine>
      </div>
    </div>
    <div class="father">
      <div>
        <h1>Main heading</h1>
        <h2>Sub heading</h2>
      </div>
      <div>
        <article>
          <img src="../../../static/img/供餐-1.jpg" />
          <h2></h2>
          <div class="content_div">
            <h3>自选餐模式</h3>
            <div class="litter_line"></div>

            <p>
              丰富的各类小炒菜品，多样化的面食、杂粮食品、养生汤类，更融入员工青睐的铁板烧、小汤锅等形式，一菜一价，明码标价，让员工自由选择。
            </p>
            <p class="last_p">· 面食</p>
            <p>· 杂粮</p>
            <p>· 养生汤类</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/供餐-2.jpg" />
          <div class="content_div">
            <h3>自助餐模式</h3>
            <div class="litter_line"></div>
            <p>
              各类蔬菜、海鲜、肉类、面食、汤羹、水果等丰富品类配置，应有尽有。结合多种自助餐配餐标准，满足不同人群就餐需求。
            </p>
            <p class="last_p">· 丰富品类</p>
            <p>· 价格亲民</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/供餐-3.jpg" />
          <div class="content_div">
            <h3>商务套餐模式</h3>
            <div class="litter_line"></div>
            <p>荤素搭配的商务套餐，确保营养健康，让员工自由选择。</p>
            <p class="last_p">· 荤素搭配</p>
            <p>· 营养健康</p>
            <p>· 自由选择</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/供餐-4.jpg" />
          <div class="content_div">
            <h3>休闲模式</h3>
            <div class="litter_line"></div>
            <p>
              各类特色小吃，老铺子烤饼，一芳水果茶，喜捞水果捞等特色品牌，满足员工休闲所需。
            </p>
            <p class="last_p">· 特色小吃</p>
            <p>· 特色档口</p>
            <p>· 休闲选择</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import ShowLine from "../../components/ShowLine.vue";
export default {
  components: {
    ShowLine,
  },
  data() {
    return {};
  },
  mounted() {
    this.Init();
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  methods: {
    Init() {},
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.bottommenu {
  background-color: #545c64;
}

.el-menu-demo {
  margin-top: 3px;
}

.elcol {
  padding: 0;
}

.heading {
  padding: 5rem 0 0 0;
  font-size: 4.8rem;
  color: var(--textBlue);
  text-align: center;
  font-family: bold;
}

.sub_heading {
  font-size: 1.5rem;
  color: var(--textBlue);
  text-align: center;
}

.tv_content {
  margin: auto;
  width: 60%;
  font-size: 1rem;
  color: #4c4948;
  text-align: center;
  line-height: 2rem;
}

.litter_line {
  display: inline-block;
  margin: 8rem 10rem 3rem 10rem;
  background-color: white;
  height: 1px;
  width: 20% !important;
}

.father {
  width: 50vw;
  height: 50vh;
  margin: 5rem auto;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;

    h3 {
      margin: 10rem 0 0 10rem;
      font-size: 3rem;
      font-family: bold;
    }

    p {
      margin: 0 10rem 0 10rem;
      width: auto;
      font-size: 14px;
      line-height: 3rem;
    }

    .last_p {
      margin: 2rem 10rem 0 10rem;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 25%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 10%;
  }

  div + div article:hover {
    width: 70%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }

  @media (min-width: 1300px) {
    .litter_line {
      margin: 4rem 5rem 1rem 5rem;
    }

    .content_div {
      h3 {
        margin: 5rem 0 0 5rem;
      }

      p {
        margin: 0 5rem 0 5rem;
        line-height: 2.5rem;
      }

      .last_p {
        margin: 1rem 5rem 0 5rem;
      }

      .first_p {
        margin: 5rem 5rem 0 5rem;
      }
    }
  }

  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>
